import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { emotionCSSToStyle } from 'styles/utils'

export const FilterContainer = styled.div`
  margin-right: 14px;
`

export const autocompleteContainer = css`
  min-width: 33%;
  position: relative;
  top: 1px;
`

export const datepickerContainer = css`
  max-width: 160px;

  > div {
    background-color: #fff;
  }

  input {
    padding-top: 9.94px;
    padding-bottom: 9.94px;
    text-transform: uppercase;
  }

  fieldset {
    border-color: rgb(229, 229, 229) !important;
  }
`

export const selectStyle = emotionCSSToStyle(css`
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
`)
